import React, { useState, useContext } from "react";

import { AuthContext } from "../../contexts/auth";



import './styles.css';

import imglogo from '../../img/logomarca.png'

import imgentrada from '../../img/teste.jpg'

const LoginPage = () => {
    const { authenticated, login } = useContext(AuthContext);

    const [email, setemail] = useState("");
    const [password, setPassword] = useState("");

    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("perfil");

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("submit", { email, password });
        login(email, password);
    };


    return (

        <div className="main">
            <div className="overlay"></div>


            <img src={imgentrada} autoPlay loop muted />

            <div className="content">
                <div className="login1" id="login">

                    <form className="form-signin" onSubmit={handleSubmit}>

                        <img className="logomarca" src={imglogo} autoPlay loop muted />

                        <div className="form-floating">
                            <label htmlFor="email" for="floatingInput" className="control-label" >E-Mail</label>
                            <input type="email" className="form-control" name="email" id="email" placeholder="email" value={email} onChange={(e) => setemail(e.target.value)} />
                        </div>
                        <div className="form-floating">
                            <label htmlFor="password" for="floatingPassword" className="control-label">Senha</label>
                            <input type="password" className="form-control form-control-sm" name="password" id="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>
                        <div className="links">
                            <br></br>
                            <a href="./enviaReset" className="mx-3">Novo Cadastro</a>
                            <a href="./enviaReset" className="mx-3">Resetar Senha</a>
                        </div>
                        <div className="actions">
                            <button type="submit" className="btn btn-outline-primary btn-lg btn-banner" id="button">Entrar</button>
                        </div>

                    </form>

                </div>
            </div>



        </div>
    );

};

export default LoginPage